import { call, put, takeLatest, all } from 'redux-saga/effects';
import {
  GET_PAYSLIP_DETAIL,
  GET_PAYSLIP_OVERVIEW,
  GET_PAYSLIP_YEAR,
  GET_FILE_PAYSLIP_DETAIL,
} from './constants';
import {
  setPayslipDetail,
  setPayslipOverview,
  setPayslipYear,
  exportPayslipDetail,
} from './actions';
import { loadingRequest, loadingSuccess } from '@stores/global/actions';
import { hasValue } from '@helpers/utils/utils';
import {
  getPayslipOverviewService,
  getPayslipYearsListService,
  getPayslipDetailService,
  exportPayslipDetailService,
} from '@services/payslip/payslip';
import { formatCurrency } from '@helpers/numberUtils';
import { formatAnyDate } from '@helpers/dateUtils';

export function* getPayslipYearsList({ payload }) {
  try {
    yield put(loadingRequest());
    const isHousehold = payload;
    const response = yield call(getPayslipYearsListService, { isHousehold });
    if (hasValue(response)) {
      const yearsList = [];
      response.years.sort((a, b) => parseInt(b) - parseInt(a));
      response.years.forEach((element) => {
        yearsList.push({
          yearCode: element,
          yearName: `${element}`,
        });
      });

      if (response?.years) {
        if (response.years.length > 0) {
          yield put(setPayslipYear(yearsList));
          yield getPayslipOverview({
            payload: {
              year: new Date().getFullYear().toString(),
              isHousehold,
            },
          });
        } else {
          const overview = {};
          const paidDatesList = [];
          yield put(
            setPayslipYear([
              {
                yearCode: new Date().getFullYear(),
                yearName: new Date().getFullYear().toString(),
              },
            ]),
          );
          yield put(
            setPayslipOverview({
              overview,
              paidDatesList,
            }),
          );
        }
      }
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export function* getPayslipOverview({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPayslipOverviewService, {
      year: payload.year,
      isHousehold: payload?.isHousehold || false,
    });

    const overview = {};
    const paidDatesList = [];
    if (hasValue(response) && response.length > 0) {
      response.sort(
        (a, b) => new Date(b.paymentDate) - new Date(a.paymentDate),
      );

      response.forEach((element) => {
        const role = element?.type || '';
        let transferAmount = '-';
        if (role?.includes('ACB') && element.totalAmount) {
          transferAmount = formatCurrency(element.totalAmount, '.');
        } else if (element.transferAmount) {
          transferAmount = formatCurrency(element.transferAmount, '.');
        }
        paidDatesList.push({
          ...element,
          key: element.paymentDate,
          paymentDate: formatAnyDate(element.paymentDate),
          amount: transferAmount,
        });
      });
    }

    yield put(
      setPayslipOverview({
        overview,
        paidDatesList,
      }),
    );
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export function* getPayslipDetail({ payload, callback }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPayslipDetailService, {
      paidDate: payload.paidDate,
      type: payload.type,
    });
    if (hasValue(response)) {
      yield put(setPayslipDetail(response));
      if (callback) callback();
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export function* exportPayslipDetailSaga({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(exportPayslipDetailService, {
      paidDate: payload.paidDate,
      type: payload.type,
    });
    if (hasValue(response)) {
      yield put(exportPayslipDetail(response.link));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
  }
}

export default function* payslipSaga() {
  yield takeLatest(GET_PAYSLIP_YEAR, getPayslipYearsList);
  yield takeLatest(GET_PAYSLIP_OVERVIEW, getPayslipOverview);
  yield takeLatest(GET_PAYSLIP_DETAIL, getPayslipDetail);
  yield takeLatest(GET_FILE_PAYSLIP_DETAIL, exportPayslipDetailSaga);
}
